function save(key, data) {
    key = `v1_${key}`.toLowerCase();
    try {
        localStorage.setItem(key, JSON.stringify(data));
    }
    catch (err) {
        console.log('could not store', key, data);
    }
}
function load(key, defaultValue) {
    key = `v1_${key}`.toLowerCase();
    try {
        let v = localStorage.getItem(key);
        if (v) {
            let ob = JSON.parse(v);
            return ob;
        }
    }
    catch (err) {
        console.log('could not load', key);
    }
    if (typeof defaultValue == 'function')
        return defaultValue();
    return defaultValue;
}
function clear() {
    try {
        localStorage.clear();
    }
    catch (err) {
        console.log('could not clear storage');
    }
}
export default {
    save,
    load,
    clear
};
export { save, load, clear };
